import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "50",
  height: "50",
  viewBox: "0 0 23 23"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#f59600",
  d: "M11.5 0A11.5 11.5 0 1 1 0 11.5 11.5 11.5 0 0 1 11.5 0z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#1d2a64",
  d: "m15.693 7.857-.554-.554-3.639 3.643-3.643-3.639-.55.55 3.639 3.643-3.639 3.639.554.554 3.639-3.636 3.639 3.639.554-.554-3.636-3.642z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };